import { useSelector } from 'react-redux';

import { BuildingDescription } from './components/BuildingDescription';
import { BuildingGallery } from './components/BuildingGallery';
import { BuildingHeader } from './components/BuildingHeader';
import { BuildingMainBlock } from './BuildingMainBlock';
import { BuildingMainProps } from './components/BuildingMainProps';
import { BuildingStakeholders } from './components/BuildingStakeholders';
import { BuildingContactsContainer } from 'shared/components/BuildingContacts';
import { BuildingDetailsContainer } from 'shared/components/BuildingDetails';
import { OffersAnchorsContainer } from 'shared/components/OffersAnchors';
import { selectBuildingCard } from 'shared/selectors/buildingCard';
import { getBuildingDescription } from 'shared/utils/buildingDescription';
import { getPhotoAlts } from 'shared/utils/buildingSeo';
import { FLOATING_HEADER_BREAKPOINT_ID } from 'shared/utils/floatingHeader';
import {
  getAddressText,
  getBuildingTitle,
  getDescriptionTitle,
  getMainProps,
  getMetroIcon,
  getParentLabel,
  getRates,
  getUndergrounds,
} from 'shared/utils/buildingMainBlock';

export const BuildingMainBlockContainer = () => {
  const card = useSelector(selectBuildingCard);
  const parentLabel = getParentLabel(card);
  const description = getBuildingDescription(card);

  return (
    <BuildingMainBlock
      header={
        <BuildingHeader
          parent={card.parent && parentLabel ? { label: parentLabel, url: card.parent.url } : null}
          title={getBuildingTitle(card)}
          address={getAddressText(card)}
          isAddressLink={card.coordinates !== null}
          undergrounds={getUndergrounds(card)}
          metroIcon={getMetroIcon(card)}
        />
      }
      left={
        <>
          <BuildingGallery photos={card.photos} alts={getPhotoAlts(card)} />
          {/* Плавающая шапка появляется, когда этот маркер уходит под неё */}
          <div id={FLOATING_HEADER_BREAKPOINT_ID} />
          <BuildingDescription
            title={getDescriptionTitle(card)}
            text={description}
            photoSources={card.photoSourceUrls}
          />
          <BuildingStakeholders developer={card.developer} managementCompany={card.managementCompany} />
        </>
      }
      right={
        <>
          <BuildingMainProps props={getMainProps(card)} rates={getRates(card)} />
          <OffersAnchorsContainer />
          <BuildingContactsContainer />
          <BuildingDetailsContainer />
        </>
      }
    />
  );
};
